<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <div class="mydoc">
      <div class="header" style="font-weight: 900">{{ $t('submission.headerTitle') }}</div>
      <div class="mybody">
        <p>
          {{ $t('submission.scope') }}
        </p>
        <p>
          {{ $t('submission.method.title') }}：{{ $t('submission.method.content') }}
        </p>
        <p>
          {{ $t('submission.requirements.title') }} {{ $t('submission.requirements.languages') }} {{ $t('submission.requirements.structure') }}
        </p>
        <p>
          {{ $t('submission.format.title') }}
          {{ $t('submission.format.paper') }}
          {{ $t('submission.format.titleFont') }}
          {{ $t('submission.format.bodyFont') }}
          {{ $t('submission.format.notes') }}
          {{ $t('submission.format.references') }}
        </p>
        <p>{{ $t('submission.template.title') }}</p>
        <el-row>
          <el-col
            v-for="(link, index) in $t('submission.template.links').split('\n')"
            :key="index"
            :span="12"
            style="cursor: pointer; color: #006a71"
            @click.native="index === 0 ? downloadChinese() : downloadEnglish()"
          >{{ link }}</el-col>
        </el-row>
      </div>
    </div>
  </el-col>
</template>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "guidelines",
  components: {
    loginComponent,
  },
  data() {
    return {};
  },
  methods: {
    downloadChinese() {
      window.open(
        "http://www.exp-linguistics.net/file/%E8%AE%BA%E6%96%87%E6%A8%A1%E6%9D%BF.docx",
        "_blank"
      );
    },
    downloadEnglish() {
      window.open(
        "http://www.exp-linguistics.net/file/英文论文模板.docx",
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/guidelines.vue